import script from "./IconMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconMenu.vue?vue&type=script&setup=true&lang=ts"

import "./IconMenu.vue?vue&type=style&index=0&id=ef988598&lang=css"

const __exports__ = script;

export default __exports__